

import rectangle from "../../assets/images/bannerimg1.png";
import eagle from "../../assets/images/bannerimg2.png";
import Button from "../Button/Button";
import cart from "../../assets/images/cart.png";

export default function HomeBanner() {

  const handleWatchVideos = () => {
    alert("button clicked");
  };

  const Buttonui = ({ text }) => {
    return (
      <button className="bg-[#F69837] flex gap-2 py-2 px-4 items-center rounded-3xl text-white hover:bg-[#e0892f] transition-all w-fit">
        <img src={cart} className="w-4 h-4 sm:w-5 sm:h-5" alt="cart" />
        <span className="text-xs sm:text-sm lg:text-base font-medium">
          {text}
        </span>
      </button>
    );
  };

  return (
    <section className="relative overflow-hidden mb-10 bg-no-repeat bg-cover bg-top homeBgImage py-12 lg:py-0 lg:min-h-screen flex items-center">

      <div className="container mx-auto px-4 sm:px-6 lg:px-10">
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          
          <div className="space-y-6 lg:space-y-8 text-center lg:text-left z-30">
            
            <div className="space-y-3">
              
              <h1 className="textFont text-2xl sm:text-3xl md:text-4xl lg:text-6xl xl:text-7xl leading-tight text-black">
                Welcome to Kitehawk Learning
              </h1>

              <h1 className="textFont text-2xl sm:text-3xl md:text-4xl lg:text-6xl xl:text-7xl leading-tight text-black">
                Spelling & Literacy Program
              </h1>

            </div>

            <p className="text-sm sm:text-base lg:text-lg text-gray-600 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              No matter your age, we can help you improve your written and spoken
               English through phonics. 
              <br className="hidden md:block" />
              <br className="hidden md:block" />
              Kitehawk is a sequential, phonics-based spelling and literacy
              program that teaches students basic spelling skills and strategies
              needed to improve their literacy.
            </p>

            <div className="flex flex-col items-center lg:items-start gap-3">
              <Buttonui text="Buy Books (Aust Version) from Amazon" />
              <Buttonui text="Buy Books (USA Version) from Amazon" />
              <Buttonui text="Buy Books (Aust Version) Direct from Author" />
            </div>

            <div className="pt-4 flex justify-center lg:justify-start">
              <Button text="Learn Online" onClick={handleWatchVideos} />
            </div>
          </div>

          <div className="relative flex items-center justify-center w-full h-[300px] sm:h-[400px] md:h-[500px] lg:h-[600px]">
            
            <div className="absolute inset-0 flex justify-center lg:justify-end items-center">
              <img
                src={eagle}
                alt="Background Eagle"
                className="w-full h-full object-contain opacity-40 lg:opacity-100"
              />
            </div>

            <div className="relative z-20 flex justify-center bottom-10 lg:bottom-20 items-center">
              <img
                src={rectangle}
                alt="Kitehawk Book"
                className="w-[160px] sm:w-[220px] md:w-[280px] lg:w-[350px] xl:w-[420px] object-contain drop-shadow-2xl"
              />
            </div>

            <div className="absolute left-2 sm:left-6 bottom-4 sm:bottom-10 z-30 bg-[#F69837] w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 rounded-full flex flex-col items-center justify-center text-[8px] sm:text-[10px] md:text-xs lg:text-sm text-white text-center p-3 shadow-lg">
              
              <p>
                <span className="text-[#2066B7]">Confident</span> spellers
              </p>

              <p className="text-[#2066B7] my-1">make confident</p>

              <p>
                readers <span className="text-[#2066B7]">and</span> writers
              </p>

            </div>

          </div>

        </div>

      </div>
    </section>
  );
}